/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileBundleMiniReference,
    MediaFileBundleMiniReferenceFromJSON,
    MediaFileBundleMiniReferenceFromJSONTyped,
    MediaFileBundleMiniReferenceToJSON,
    SubclipReference,
    SubclipReferenceFromJSON,
    SubclipReferenceFromJSONTyped,
    SubclipReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubclipClipboardEntryUpdate
 */
export interface SubclipClipboardEntryUpdate {
    /**
     * 
     * @type {SubclipReference}
     * @memberof SubclipClipboardEntryUpdate
     */
    cut: SubclipReference;
    /**
     * 
     * @type {MediaFileBundleMiniReference}
     * @memberof SubclipClipboardEntryUpdate
     */
    bundle?: MediaFileBundleMiniReference;
}

export function SubclipClipboardEntryUpdateFromJSON(json: any): SubclipClipboardEntryUpdate {
    return SubclipClipboardEntryUpdateFromJSONTyped(json, false);
}

export function SubclipClipboardEntryUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubclipClipboardEntryUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cut': SubclipReferenceFromJSON(json['cut']),
        'bundle': !exists(json, 'bundle') ? undefined : MediaFileBundleMiniReferenceFromJSON(json['bundle']),
    };
}

export function SubclipClipboardEntryUpdateToJSON(value?: SubclipClipboardEntryUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cut': SubclipReferenceToJSON(value.cut),
        'bundle': MediaFileBundleMiniReferenceToJSON(value.bundle),
    };
}


